'use client'

import { List, Search, ChevronDown, ChevronUp, Info, X } from 'lucide-react'
import '@/modules/hs/styles/hs-detail.css'
import { useState, useMemo } from 'react'
import EmptyState from './component/EmptyState'

interface HsOtherDescriptionSectionProps {
  motaKhac?: string[]
}

export default function HsOtherDescriptionSection({
  motaKhac,
}: HsOtherDescriptionSectionProps) {
  const [isExpanded, setIsExpanded] = useState(false)
  const [filterText, setFilterText] = useState('')

  // Filter descriptions based on search text
  const filteredDescriptions = useMemo(() => {
    if (!motaKhac || motaKhac.length === 0) return []
    if (!filterText.trim()) {
      return motaKhac
    }
    return motaKhac.filter((desc) =>
      desc.toLowerCase().includes(filterText.toLowerCase()),
    )
  }, [motaKhac, filterText])

  // Auto expand when filtering
  const visibleItems =
    filterText || isExpanded
      ? filteredDescriptions
      : filteredDescriptions.slice(0, 5)
  const hasMore = filteredDescriptions.length > 5 && !filterText

  const hasData = motaKhac && motaKhac.length > 0

  return (
    <section id="descriptions" className="cl-card-border mt-6">
      <div className="section-header">
        <div>
          <h2 className="text-lg font-bold ">
            <List className="inline-block w-6 h-6 mr-2 text-blue-600" />
            Mô tả khác
          </h2>
          <p className="section-subtitle">
            Các mô tả thực tế khác về hàng hóa để tham khảo
          </p>
        </div>
      </div>

      {!hasData ? (
        <EmptyState
          title="Đang cập nhật"
        />
      ) : (
        <>
          <div className="filter-input-wrapper">
            <Search className="filter-input-icon" />
            <input
              type="text"
              placeholder="Tìm kiếm mô tả..."
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              className="filter-input"
            />
            {filterText && (
              <button
                onClick={() => setFilterText('')}
                className="filter-clear-btn"
                aria-label="Xóa tìm kiếm"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>

          {filterText && (
            <div className="filter-result-info">
              Tìm thấy <strong>{filteredDescriptions.length}</strong> kết quả
              {filteredDescriptions.length === 0 && ' - Thử từ khóa khác'}
            </div>
          )}

          <div className="description-list">
            {visibleItems.map((description, index) => (
              <div key={index} className="description-item">
                <div className="description-text">{description}</div>
              </div>
            ))}
          </div>

          {hasMore && (
            <div className="related-toggle-wrapper">
              <button
                className="related-toggle-btn"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                <span>{isExpanded ? 'Thu gọn' : 'Xem thêm'}</span>
                {isExpanded ? (
                  <ChevronUp className="w-4 h-4" />
                ) : (
                  <ChevronDown className="w-4 h-4" />
                )}
              </button>
            </div>
          )}
        </>
      )}
    </section>
  )
}
